import React, { useId } from "react";
import { Stack, TextField, useMediaQuery } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment";

/**
 * Valida un rango de fechas de reporte.
 * @returns {string|null} El mensaje de error, o null si el rango es válido.
 */
export const validarRangoFechas = (desde, hasta) => {
  if (!moment(desde).isValid()) return "Seleccione una fecha inicial válida";
  if (!moment(hasta).isValid()) return "Seleccione una fecha final válida";
  if (moment(hasta).isBefore(moment(desde), "day"))
    return "La fecha final no puede ser anterior a la inicial";
  return null;
};

/** Un campo de fecha de reporte (DD/MM/YYYY), a todo el ancho; con id para unir la etiqueta al campo. */
export const CampoFecha = ({ label, value, onChange }) => {
  const id = useId();
  return (
    <DesktopDatePicker
      closeOnSelect
      label={label}
      inputFormat="DD/MM/YYYY"
      value={value}
      onChange={onChange}
      renderInput={(params) => <TextField fullWidth {...params} id={id} />}
    />
  );
};

/**
 * Desde y Hasta en una sola fila.
 *
 * @param {object} props
 * @param {Date|object} props.desde
 * @param {Date|object} props.hasta
 * @param {(valor: any) => void} props.onChangeDesde
 * @param {(valor: any) => void} props.onChangeHasta
 */
export const RangoFechas = ({ desde, hasta, onChangeDesde, onChangeHasta }) => {
  // Por debajo de 380 px (teléfonos de 360–375) el año se cortaba: una debajo de la otra.
  const angosto = useMediaQuery("(max-width:379.95px)");
  return (
    <Stack direction={angosto ? "column" : "row"} spacing={angosto ? 2.5 : { xs: 1, sm: 2 }}>
      <CampoFecha label="Desde" value={desde} onChange={onChangeDesde} />
      <CampoFecha label="Hasta" value={hasta} onChange={onChangeHasta} />
    </Stack>
  );
};
